import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Wine as WineIcon } from "lucide-react";
import { useLang } from "../LanguageContext";
import { IMAGES } from "../content";
import { Reveal } from "./Reveal";

export const Wine = () => {
  const { t } = useLang();
  const w = t.wine;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-7%", "7%"]);

  return (
    <section id="wine" ref={ref} className="bg-brown py-24 md:py-36" data-testid="wine-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <Reveal delay={0.1} y={50}>
            <div className="relative aspect-[4/3] overflow-hidden rounded-xl shadow-2xl shadow-black/30">
              <motion.img
                style={{ y, scale: 1.12, objectPosition: "center 42%" }}
                src={IMAGES.wine}
                alt="Illuminated wine wall at Restaurante São João"
                loading="lazy"
                className="h-full w-full object-cover"
              />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5 order-1 lg:order-2">
          <Reveal>
            <div className="flex items-center gap-3 text-gold text-xs uppercase tracking-[0.35em] mb-6">
              <WineIcon size={16} strokeWidth={1.5} />
              {w.chapter}
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif text-ivory text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">{w.title}</h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-ivory/70 text-lg font-light leading-relaxed">{w.body}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-8 text-gold text-sm uppercase tracking-[0.25em]">{w.tag}</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
